import { StyledSpacer } from './styled';
import { SpacerProps } from './types';

export type { SpacerProps } from './types';

/**
 * Vertical spacing between elements.
 * Uses the theme.space object to determine the spacing.
 *
 * @example
 * <Spacer size="xl" hideFrom="md" />
 *
 * @example
 * <Spacer customFrom={{ '500px': 'xl', '1000px': 'sm' }} />
 */
export const Spacer = (props: SpacerProps) => <StyledSpacer aria-hidden {...props} />;

export default Spacer;
